import React from 'react';
import { Option } from 'rc-select';

function optionRenderDefault(option) {
  const label = option.label || option.text || option.name;
  return (
    <Option
      key={option.key || option.value}
      value={option.value}
      search={label}
      disabled={option.disabled}
    >
      {label}
    </Option>
  );
}

export default function useOptionRender({
  optionRender = optionRenderDefault,
  options,
  children,
  ...props
}) {
  // 将 options 转换为 children
  if (typeof optionRender === 'function' && Array.isArray(options)) {
    return {
      ...props,
      children: options.map(optionRender),
    };
  }
  return { children, options, ...props };
}
